import { default as indexutcnovDtlEMeta } from "/vercel/path0/pages/about/index.vue?macro=true";
import { default as reskillingf6scIUH66KMeta } from "/vercel/path0/pages/benefits/reskilling.vue?macro=true";
import { default as indexJFmZsJLqDNMeta } from "/vercel/path0/pages/biz/training/course/first-prompt-engineering/index.vue?macro=true";
import { default as indexVf2tJc0DDdMeta } from "/vercel/path0/pages/biz/training/index.vue?macro=true";
import { default as index9FE4cnbC5WMeta } from "/vercel/path0/pages/biz/training/lp/team/[team]/index.vue?macro=true";
import { default as indexiVwlYCgHgvMeta } from "/vercel/path0/pages/biz/training/operations/index.vue?macro=true";
import { default as indexSliKKjDjKJMeta } from "/vercel/path0/pages/biz/training/special/generative-ai-series/index.vue?macro=true";
import { default as index79ETaXHGYLMeta } from "/vercel/path0/pages/career-about/index.vue?macro=true";
import { default as indexTHqTRxlhV2Meta } from "/vercel/path0/pages/company/index.vue?macro=true";
import { default as indexDBbnZWdxZ3Meta } from "/vercel/path0/pages/contact/index.vue?macro=true";
import { default as indexuIEwXf9C56Meta } from "/vercel/path0/pages/cookiepolicy/index.vue?macro=true";
import { default as htmlcss_45scheduleHftv4G6zwkMeta } from "/vercel/path0/pages/counseling/htmlcss-schedule.vue?macro=true";
import { default as aiPZjNXcOHtRMeta } from "/vercel/path0/pages/course/ai.vue?macro=true";
import { default as androidEvBkWCl8EBMeta } from "/vercel/path0/pages/course/android.vue?macro=true";
import { default as datascienceb4Dg3ZbqgIMeta } from "/vercel/path0/pages/course/datascience.vue?macro=true";
import { default as design_45portfoliodT6w9ZomacMeta } from "/vercel/path0/pages/course/design-portfolio.vue?macro=true";
import { default as first_45programmingmkQu7bXJqkMeta } from "/vercel/path0/pages/course/first-programming.vue?macro=true";
import { default as first_45prompt_45engineeringN9FSZunrsVMeta } from "/vercel/path0/pages/course/first-prompt-engineering.vue?macro=true";
import { default as first_45sidejob_45oneonone_45plan5wYwwh2Ql0Meta } from "/vercel/path0/pages/course/first-sidejob-oneonone-plan.vue?macro=true";
import { default as first_45sidejobK4KjAQBCNtMeta } from "/vercel/path0/pages/course/first-sidejob.vue?macro=true";
import { default as frontendYVaVm5Fd8FMeta } from "/vercel/path0/pages/course/frontend.vue?macro=true";
import { default as indexfkRBc6uRMrMeta } from "/vercel/path0/pages/course/index.vue?macro=true";
import { default as iphoneKvxyFmnDaXMeta } from "/vercel/path0/pages/course/iphone.vue?macro=true";
import { default as javaCpa4UKKS87Meta } from "/vercel/path0/pages/course/java.vue?macro=true";
import { default as llm_45developmentYEUJfSaxx8Meta } from "/vercel/path0/pages/course/llm-development.vue?macro=true";
import { default as occupationffrGnJ1K1rMeta } from "/vercel/path0/pages/course/occupation.vue?macro=true";
import { default as ordermade_45entryYseoF9N5GYMeta } from "/vercel/path0/pages/course/ordermade-entry.vue?macro=true";
import { default as ordermadeMrahjG2d7WMeta } from "/vercel/path0/pages/course/ordermade.vue?macro=true";
import { default as pythonLSBQCWGOgdMeta } from "/vercel/path0/pages/course/python.vue?macro=true";
import { default as unityPfzMLzyQZRMeta } from "/vercel/path0/pages/course/unity.vue?macro=true";
import { default as webdesignzxtamkRGceMeta } from "/vercel/path0/pages/course/webdesign.vue?macro=true";
import { default as webdevelopment_45advancedeWh7EFUNM1Meta } from "/vercel/path0/pages/course/webdevelopment-advanced.vue?macro=true";
import { default as webmarketingEJdvbmXjHHMeta } from "/vercel/path0/pages/course/webmarketing.vue?macro=true";
import { default as wordpressIPy3pFhKnnMeta } from "/vercel/path0/pages/course/wordpress.vue?macro=true";
import { default as completed_a7gPeWqF67jMeta } from "/vercel/path0/pages/diagnoses/completed_a.vue?macro=true";
import { default as completed_bbnbeRPPWHpMeta } from "/vercel/path0/pages/diagnoses/completed_b.vue?macro=true";
import { default as completed_cgh3OO7r4WVMeta } from "/vercel/path0/pages/diagnoses/completed_c.vue?macro=true";
import { default as completed_dX1e4RplamUMeta } from "/vercel/path0/pages/diagnoses/completed_d.vue?macro=true";
import { default as completed_eD8zMBDBK96Meta } from "/vercel/path0/pages/diagnoses/completed_e.vue?macro=true";
import { default as completed_fA8bKPbdwb6Meta } from "/vercel/path0/pages/diagnoses/completed_f.vue?macro=true";
import { default as completed_gssJYDJsQr0Meta } from "/vercel/path0/pages/diagnoses/completed_g.vue?macro=true";
import { default as completed_isPVNPuVTtyMeta } from "/vercel/path0/pages/diagnoses/completed_i.vue?macro=true";
import { default as completed_jpFNTP6gKYzMeta } from "/vercel/path0/pages/diagnoses/completed_j.vue?macro=true";
import { default as completed_kfqdu3TYFgKMeta } from "/vercel/path0/pages/diagnoses/completed_k.vue?macro=true";
import { default as completed_lgNhJvf2A3WMeta } from "/vercel/path0/pages/diagnoses/completed_l.vue?macro=true";
import { default as completed_nXAc9TiA0CKMeta } from "/vercel/path0/pages/diagnoses/completed_n.vue?macro=true";
import { default as completed_odUe2A7cV5UMeta } from "/vercel/path0/pages/diagnoses/completed_o.vue?macro=true";
import { default as completed_pYbkne6HDV3Meta } from "/vercel/path0/pages/diagnoses/completed_p.vue?macro=true";
import { default as completed_qYzsGpHsPAQMeta } from "/vercel/path0/pages/diagnoses/completed_q.vue?macro=true";
import { default as completed_ruLO7xwUZW1Meta } from "/vercel/path0/pages/diagnoses/completed_r.vue?macro=true";
import { default as completed_scHlDGnsgDxMeta } from "/vercel/path0/pages/diagnoses/completed_s.vue?macro=true";
import { default as completed_t7rwAxEdQVxMeta } from "/vercel/path0/pages/diagnoses/completed_t.vue?macro=true";
import { default as q1bfdinuVYi9Meta } from "/vercel/path0/pages/diagnoses/q1.vue?macro=true";
import { default as q2_aBpKZ8qldvFMeta } from "/vercel/path0/pages/diagnoses/q2_a.vue?macro=true";
import { default as q2_bBg0jHoC3kjMeta } from "/vercel/path0/pages/diagnoses/q2_b.vue?macro=true";
import { default as q2_cp8O6wPMhowMeta } from "/vercel/path0/pages/diagnoses/q2_c.vue?macro=true";
import { default as q2_dmpziMC4GvjMeta } from "/vercel/path0/pages/diagnoses/q2_d.vue?macro=true";
import { default as q2_eoQ2AginqY1Meta } from "/vercel/path0/pages/diagnoses/q2_e.vue?macro=true";
import { default as q3_ala8GrIjZM4Meta } from "/vercel/path0/pages/diagnoses/q3_a.vue?macro=true";
import { default as q3_bG4GSsVa2JKMeta } from "/vercel/path0/pages/diagnoses/q3_b.vue?macro=true";
import { default as q3_cMDMHLIXFezMeta } from "/vercel/path0/pages/diagnoses/q3_c.vue?macro=true";
import { default as q3_fqoV6IEEcW1Meta } from "/vercel/path0/pages/diagnoses/q3_f.vue?macro=true";
import { default as q4_a3AQQwgBd5FMeta } from "/vercel/path0/pages/diagnoses/q4_a.vue?macro=true";
import { default as topyz3qXdT99tMeta } from "/vercel/path0/pages/diagnoses/top.vue?macro=true";
import { default as _404g7vP261HeaMeta } from "/vercel/path0/pages/errors/404.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as index27xh5qC0QjxMeta } from "/vercel/path0/pages/index2.vue?macro=true";
import { default as aiqLe1eptdUDMeta } from "/vercel/path0/pages/job/ai.vue?macro=true";
import { default as android5oSmniTYKmMeta } from "/vercel/path0/pages/job/android.vue?macro=true";
import { default as datasciencewu4JKMzTcAMeta } from "/vercel/path0/pages/job/datascience.vue?macro=true";
import { default as frontendtt9BOwnvSqMeta } from "/vercel/path0/pages/job/frontend.vue?macro=true";
import { default as index358wnQ2UHrMeta } from "/vercel/path0/pages/job/index.vue?macro=true";
import { default as iphone4bjWyWbREZMeta } from "/vercel/path0/pages/job/iphone.vue?macro=true";
import { default as javaq81kz6V24NMeta } from "/vercel/path0/pages/job/java.vue?macro=true";
import { default as laravelBaxPKv7vtqMeta } from "/vercel/path0/pages/job/laravel.vue?macro=true";
import { default as phpgW1dduXftSMeta } from "/vercel/path0/pages/job/php.vue?macro=true";
import { default as unityzo8H9gWYgiMeta } from "/vercel/path0/pages/job/unity.vue?macro=true";
import { default as webdesigna0O72CvT71Meta } from "/vercel/path0/pages/job/webdesign.vue?macro=true";
import { default as webmarketingbE6PZeucjeMeta } from "/vercel/path0/pages/job/webmarketing.vue?macro=true";
import { default as indexJPPXbETK6DMeta } from "/vercel/path0/pages/jobchange/index.vue?macro=true";
import { default as indexwBWcviDWKwMeta } from "/vercel/path0/pages/law/index.vue?macro=true";
import { default as indexR0mMjgzY36Meta } from "/vercel/path0/pages/lp/branded/index.vue?macro=true";
import { default as lp_4511ASTrUcpSWMeta } from "/vercel/path0/pages/lp/branded/lp-1.vue?macro=true";
import { default as lp_45capexw5sng2CrlyMeta } from "/vercel/path0/pages/lp/branded/lp-capex.vue?macro=true";
import { default as lp_45ceoclone1JOtlS5jnyMeta } from "/vercel/path0/pages/lp/branded/lp-ceoclone.vue?macro=true";
import { default as lp_45kakakuWkYvhhj7mpMeta } from "/vercel/path0/pages/lp/branded/lp-kakaku.vue?macro=true";
import { default as schedule_45formUCvohPgBYMMeta } from "/vercel/path0/pages/lp/moocres/schedule-form.vue?macro=true";
import { default as aff_45184lNTZWLaQMeta } from "/vercel/path0/pages/lp/sidejob/aff-1.vue?macro=true";
import { default as contact_45bizctG1WHsDkWMeta } from "/vercel/path0/pages/ly/contact-biz.vue?macro=true";
import { default as contactcqWo7WTDl2Meta } from "/vercel/path0/pages/ly/contact.vue?macro=true";
import { default as counseling_45ceoclonemSAFO6JhpiMeta } from "/vercel/path0/pages/ly/counseling-ceoclone.vue?macro=true";
import { default as counseling_45lineVvhKsEKDN5Meta } from "/vercel/path0/pages/ly/counseling-line.vue?macro=true";
import { default as counseling84rvMWUo9EMeta } from "/vercel/path0/pages/ly/counseling.vue?macro=true";
import { default as chatgpt_45benefitp7JNHpdptkMeta } from "/vercel/path0/pages/ly/course/chatgpt-benefit.vue?macro=true";
import { default as chatgptOk8qzM6FCPMeta } from "/vercel/path0/pages/ly/course/chatgpt.vue?macro=true";
import { default as jobchangeHICJGBzcIPMeta } from "/vercel/path0/pages/ly/course/jobchange.vue?macro=true";
import { default as webapp_45basicQ1WBVL3C20Meta } from "/vercel/path0/pages/ly/course/webapp-basic.vue?macro=true";
import { default as webapp_45practice38XQYzFqE2Meta } from "/vercel/path0/pages/ly/course/webapp-practice.vue?macro=true";
import { default as lawpR8FVHyqAKMeta } from "/vercel/path0/pages/ly/law.vue?macro=true";
import { default as loginXmmZrncU0JMeta } from "/vercel/path0/pages/ly/login.vue?macro=true";
import { default as counseling_45formCrkt8UsDGRMeta } from "/vercel/path0/pages/ly/lp/counseling-form.vue?macro=true";
import { default as counseling_45kakakufyAurXKAnqMeta } from "/vercel/path0/pages/ly/lp/counseling-kakaku.vue?macro=true";
import { default as counseling_45ly1CnFb7GCnRMeta } from "/vercel/path0/pages/ly/lp/counseling-ly.vue?macro=true";
import { default as counselingyQmIPvUburMeta } from "/vercel/path0/pages/ly/lp/counseling.vue?macro=true";
import { default as privacypolicy6EhgJwAWQWMeta } from "/vercel/path0/pages/ly/privacypolicy.vue?macro=true";
import { default as termsUoYkUh4pqCMeta } from "/vercel/path0/pages/ly/terms.vue?macro=true";
import { default as trialgKqqGcS0l9Meta } from "/vercel/path0/pages/ly/trial.vue?macro=true";
import { default as trial_45mentoringoHiCcFNejhMeta } from "/vercel/path0/pages/ly/tutorial/trial-mentoring.vue?macro=true";
import { default as passwords1mFR4I4G80Meta } from "/vercel/path0/pages/ly/users/passwords.vue?macro=true";
import { default as indexXZMS3IsWcBMeta } from "/vercel/path0/pages/price/index.vue?macro=true";
import { default as indexbg3ekTJ1BXMeta } from "/vercel/path0/pages/privacypolicy/index.vue?macro=true";
import { default as first_45sidejob_45webdesignxybyjMOpW2Meta } from "/vercel/path0/pages/set/first-sidejob-webdesign.vue?macro=true";
import { default as iphone_45androidpqBtVspDaEMeta } from "/vercel/path0/pages/set/iphone-android.vue?macro=true";
import { default as python_45ai_45datascienceqZYsn8wc7LMeta } from "/vercel/path0/pages/set/python-ai-datascience.vue?macro=true";
import { default as python_45aiQjG8MQ18DhMeta } from "/vercel/path0/pages/set/python-ai.vue?macro=true";
import { default as python_45datascience9wyAcvMpLQMeta } from "/vercel/path0/pages/set/python-datascience.vue?macro=true";
import { default as python_45first_45prompt_45engineeringep5PJlJXswMeta } from "/vercel/path0/pages/set/python-first-prompt-engineering.vue?macro=true";
import { default as unity_45androidUvtN2FpeVXMeta } from "/vercel/path0/pages/set/unity-android.vue?macro=true";
import { default as unity_45iphoneuyNSbsSl3nMeta } from "/vercel/path0/pages/set/unity-iphone.vue?macro=true";
import { default as webdesign_45webmarketing0wr2d0QXgZMeta } from "/vercel/path0/pages/set/webdesign-webmarketing.vue?macro=true";
import { default as webdevelopment_45advancedWOU6ZQPOBAMeta } from "/vercel/path0/pages/set/webdevelopment-advanced.vue?macro=true";
import { default as webengineer_45jobchangefRctrb7CB9Meta } from "/vercel/path0/pages/set/webengineer-jobchange.vue?macro=true";
import { default as indexXpBMzYjdBGMeta } from "/vercel/path0/pages/sidejob/index.vue?macro=true";
import { default as index9OiDgfx7OcMeta } from "/vercel/path0/pages/terms/index.vue?macro=true";
import { default as photoshopQ4nCfYvXyRMeta } from "/vercel/path0/pages/training/photoshop.vue?macro=true";
import { default as trial_45mentoring2AxcvMMZMXMeta } from "/vercel/path0/pages/tutorial/trial-mentoring.vue?macro=true";
import { default as axios9FyMH1ilkcMeta } from "/vercel/path0/pages/upgrade/features/axios.vue?macro=true";
import { default as errorCpMjAwBr7XMeta } from "/vercel/path0/pages/upgrade/features/error.vue?macro=true";
import { default as form_45checkbox_45interestedn2PQXpC1sDMeta } from "/vercel/path0/pages/upgrade/features/form-checkbox-interested.vue?macro=true";
import { default as recapchaWqt4uskqEeMeta } from "/vercel/path0/pages/upgrade/features/recapcha.vue?macro=true";
import { default as intersection_45observerhYQExPVxMUMeta } from "/vercel/path0/pages/upgrade/scroll/intersection-observer.vue?macro=true";
import { default as scroll_45spylczT4EywBUMeta } from "/vercel/path0/pages/upgrade/scroll/scroll-spy.vue?macro=true";
import { default as scroll_45triggerjr8V7U2S5bMeta } from "/vercel/path0/pages/upgrade/scroll/scroll-trigger.vue?macro=true";
import { default as smooth_45scrollXu7Jf8oVcqMeta } from "/vercel/path0/pages/upgrade/scroll/smooth-scroll.vue?macro=true";
import { default as vueuse_45element_45visibilityKANNLhnjz2Meta } from "/vercel/path0/pages/upgrade/scroll/vueuse-element-visibility.vue?macro=true";
import { default as vueuse_45intersection_45observerLTEVO6Qhs8Meta } from "/vercel/path0/pages/upgrade/scroll/vueuse-intersection-observer.vue?macro=true";
import { default as modal_45default6uWmFIusBPMeta } from "/vercel/path0/pages/upgrade/ui/modal-default.vue?macro=true";
import { default as modal_45footerhdCmpymRh5Meta } from "/vercel/path0/pages/upgrade/ui/modal-footer.vue?macro=true";
import { default as modal_45form_45comfirmyUFzrpOTdlMeta } from "/vercel/path0/pages/upgrade/ui/modal-form-comfirm.vue?macro=true";
import { default as modal_45formlCswG6rerHMeta } from "/vercel/path0/pages/upgrade/ui/modal-form.vue?macro=true";
import { default as swiper_45slide_45threeWykgPTi41oMeta } from "/vercel/path0/pages/upgrade/ui/swiper-slide-three.vue?macro=true";
import { default as swiper_45slide_45twojOiygTrxL8Meta } from "/vercel/path0/pages/upgrade/ui/swiper-slide-two.vue?macro=true";
import { default as vue3_45lottieWvdqQwSEQ8Meta } from "/vercel/path0/pages/upgrade/ui/vue3-lottie.vue?macro=true";
import { default as indexcHM0maJ3uRMeta } from "/vercel/path0/pages/works/index.vue?macro=true";
export default [
  {
    path: "/course/shopify",
    redirect: "/course"
  },
  {
    path: "/course/wix",
    redirect: "/course"
  },
  {
    path: "/course/appdesign",
    redirect: "/course"
  },
  {
    path: "/course/frontend-sidejob",
    redirect: "/course/webdevelopment-advanced"
  },
  {
    path: "/course/webdesign-freelance",
    redirect: "/course"
  },
  {
    path: "/course/rails",
    redirect: "/course"
  },
  {
    path: "/course/php",
    redirect: "/course"
  },
  {
    path: "/course/first-sidejob-mom",
    redirect: "/course"
  },
  {
    path: "/course/first-sidejob-Immersive",
    redirect: "/course"
  },
  {
    path: "/course/first-sidejob-special",
    redirect: "/course"
  },
  {
    path: "/course/webdesign-special",
    redirect: "/course"
  },
  {
    path: "/set/webdesign-freelance-high-class-mentor",
    redirect: "/course"
  },
  {
    path: "/set/appdesign-iphone",
    redirect: "/course"
  },
  {
    path: "/set/iphone-android-appdesign",
    redirect: "/course"
  },
  {
    path: "/set/frontend-sidejob",
    redirect: "/set/webdevelopment-advanced"
  },
  {
    path: "/set/webdesign-freelance",
    redirect: "/course"
  },
  {
    path: "/set/rails-frontend",
    redirect: "/course"
  },
  {
    path: "/set/rails-frontend-webdesign",
    redirect: "/course"
  },
  {
    path: "/set/php-frontend",
    redirect: "/course"
  },
  {
    path: "/set/php-frontend-webdesign",
    redirect: "/course"
  },
  {
    path: "/set/wordpress-webmarketing",
    redirect: "/course"
  },
  {
    path: "/set/webdesign-wordpress",
    redirect: "/course"
  },
  {
    path: "/set/webdevelopment-advanced-special",
    redirect: "/set/webdevelopment-advanced"
  },
  {
    path: "/briefing/lp-s/appdesign",
    redirect: "/briefing"
  },
  {
    path: "/briefing/lp-s/shopify",
    redirect: "/briefing"
  },
  {
    path: "/briefing/office",
    redirect: "/briefing"
  },
  {
    path: "/briefing/rails",
    redirect: "/briefing"
  },
  {
    path: "/briefing/lp-s/rails",
    redirect: "/briefing"
  },
  {
    path: "/briefing/lp-s/php",
    redirect: "/briefing"
  },
  {
    path: "/briefing/php",
    redirect: "/briefing"
  },
  {
    path: "/briefing/wordpress",
    redirect: "/briefing"
  },
  {
    path: "/briefing/lp-s/wordpress",
    redirect: "/briefing"
  },
  {
    path: "/briefing/lp-s/potential-sidejob",
    redirect: "/course/first-sidejob"
  },
  {
    path: "/briefing/potential-sidejob",
    redirect: "/course/first-sidejob"
  },
  {
    path: "/briefing",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/all",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/iphone",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/webdesign",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/android",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/webmarketing",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/frontend",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/unity",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/first-programming",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/python",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/ai",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/datascience",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/java",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/first-sidejob",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/moocres",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/first-prompt-engineering",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/java",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/frontend",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/iphone",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/android",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/unity",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/first-programming",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/python",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/ai",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/datascience",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/webdesign",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/webmarketing",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/first-sidejob",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/programming",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/all",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/briefing/lp-s/first-prompt-engineering",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/training/htmlcss",
    redirect: "/course"
  },
  {
    path: "/training/bootstrap",
    redirect: "/course"
  },
  {
    path: "/training/github",
    redirect: "/course"
  },
  {
    path: "/pro/lp-s/jobchange-trial",
    redirect: "/"
  },
  {
    path: "/pro/jobchange",
    redirect: "/"
  },
  {
    path: "/job/appdesign",
    redirect: "/job"
  },
  {
    path: "/job/blockchain",
    redirect: "/job"
  },
  {
    path: "/job/lp/appdesign",
    redirect: "/job"
  },
  {
    path: "/job/rails",
    redirect: "/job"
  },
  {
    path: "/job/wordpress",
    redirect: "/job"
  },
  {
    path: "/ly/briefing",
    redirect: "/ly/counseling"
  },
  {
    path: "/ly/notification",
    redirect: "/ly/counseling"
  },
  {
    path: "/ly/course/pre",
    redirect: "/ly/counseling"
  },
  {
    path: "/ly/course",
    redirect: "/ly/counseling"
  },
  {
    path: "/ly/course/first-chatgpt",
    redirect: "/ly/course/chatgpt"
  },
  {
    path: "/ly/lp/counseling-women",
    redirect: "/ly/lp/counseling-2"
  },
  {
    path: "/ly/course/webapp-women",
    redirect: "/ly/course/webapp"
  },
  {
    path: "/ly/counseling-2",
    redirect: "/ly/counseling"
  },
  {
    path: "/ly/lp/counseling-3",
    redirect: "/ly/lp/counseling"
  },
  {
    path: "/ly/lp/counseling-4",
    redirect: "/ly/lp/counseling"
  },
  {
    path: "/ly/lp/counseling-2",
    redirect: "/ly/lp/counseling"
  },
  {
    path: "/seminar/lp-s",
    redirect: "/"
  },
  {
    path: "/seminar/top",
    redirect: "/"
  },
  {
    path: "/seminar/freelance",
    redirect: "/"
  },
  {
    path: "/seminar/learning",
    redirect: "/"
  },
  {
    path: "/seminar/earn",
    redirect: "/"
  },
  {
    path: "/seminar/mentor-support",
    redirect: "/"
  },
  {
    path: "/seminar/works",
    redirect: "/"
  },
  {
    path: "/trial/htmlcss-trial",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/counseling/lp/htmlcss-schedule",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/counseling/lp/htmlcss-schedule-2",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/counseling/lp/htmlcss-schedule-3",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/counseling/htmlcss-schedule-trial1",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/counseling/lp/htmlcss-schedule-ceoclone",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/diagnoses/completed_m",
    redirect: "/diagnoses/top"
  },
  {
    path: "/biz/training/lp/tis",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/tis/rails",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/rails",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/ai",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/android",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/appdesign",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/automation-with-python",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/aws",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/business-development",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/csharp",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/clang",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/data-analysis",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/datascience",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/db-design",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/docker",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/dotnet",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/dx-management",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/first-ai",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/first-dx",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/first-programming",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/frontend",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/gas",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/git-seminar",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/iphone",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/it-literacy",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/it-passport",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/it-system",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/java-bronze",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/java-silver",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/java",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/linux",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/lpic-1",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/node-js",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/oop",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/php",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/python",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/rails",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/salesforce-administrator",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/security",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/shopify",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/spring-boot",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/sql",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/swtest-basic",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/unity",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/webdesign",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/webdirection",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/webmarketing",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/windows-server",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/konicaminolta/wordpress",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/lp/sevenbank/first-programming",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/it",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/it/completed",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/it/contact",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/it/contact/completed",
    redirect: "/biz/training"
  },
  {
    path: "/biz/training/trial/htmlcss-trial",
    redirect: "/biz/training"
  },
  {
    path: "/lp/course/first-sidejob",
    redirect: "/course/first-sidejob"
  },
  {
    path: "/lp/course/first-sidejob-immersive",
    redirect: "/course/first-sidejob"
  },
  {
    path: "/trial/lp/htmlcss-trial",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/trial/lp/htmlcss-trial-sidejob",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/lp/programming/aff-2",
    redirect: "/lp/branded/lp-1"
  },
  {
    path: "/lp/webdesign/rz",
    redirect: "/lp/branded/lp-1"
  },
  {
    path: "/sidejob/lp/sidejob-detail",
    redirect: "/sidejob"
  },
  {
    path: "/works/lp/works-detail",
    redirect: "/works"
  },
  {
    path: "/works/counseling/completed",
    redirect: "/works"
  },
  {
    path: "/tutorial/counseling",
    redirect: "/"
  },
  {
    path: "/htmlcss-trial",
    redirect: "/trial/htmlcss-trial"
  },
  {
    path: "/htmlcss-trial-s2",
    redirect: "/trial/lp/htmlcss-trial"
  },
  {
    path: "/trial/lp/htmlcss-trial-2",
    redirect: "/trial/lp/htmlcss-trial"
  },
  {
    path: "/trial/lp/htmlcss-trial-line",
    redirect: "/trial/lp/htmlcss-trial"
  },
  {
    path: "/briefing/webapp",
    redirect: "/briefing/rails"
  },
  {
    path: "/biz/lp-dx",
    redirect: "/biz/training/dx"
  },
  {
    path: "/briefing-lp-webapp-s",
    redirect: "/briefing/lp-s/rails"
  },
  {
    path: "/briefing-lp-php-s",
    redirect: "/briefing/lp-s/php"
  },
  {
    path: "/briefing-lp-java-s",
    redirect: "/briefing/lp-s/java"
  },
  {
    path: "/briefing-lp-frontend-s",
    redirect: "/briefing/lp-s/frontend"
  },
  {
    path: "/briefing-lp-wordpress-s",
    redirect: "/briefing/lp-s/wordpress"
  },
  {
    path: "/briefing-lp-iphone-s",
    redirect: "/briefing/lp-s/iphone"
  },
  {
    path: "/briefing-lp-android-s",
    redirect: "/briefing/lp-s/android"
  },
  {
    path: "/briefing-lp-unity-s",
    redirect: "/briefing/lp-s/unity"
  },
  {
    path: "/briefing-lp-first-programming-s",
    redirect: "/briefing/lp-s/first-programming"
  },
  {
    path: "/briefing-lp-python-s",
    redirect: "/briefing/lp-s/python"
  },
  {
    path: "/briefing-lp-ai-s",
    redirect: "/briefing/lp-s/ai"
  },
  {
    path: "/briefing-lp-datascience-s",
    redirect: "/briefing/lp-s/datascience"
  },
  {
    path: "/briefing-lp-node-js-s",
    redirect: "/"
  },
  {
    path: "/briefing/lp-s/node-js",
    redirect: "/"
  },
  {
    path: "/briefing-lp-gas-s",
    redirect: "/briefing/lp-s/gas"
  },
  {
    path: "/briefing-lp-webdesign-s",
    redirect: "/briefing/lp-s/webdesign"
  },
  {
    path: "/briefing-lp-appdesign-s",
    redirect: "/briefing/lp-s/appdesign"
  },
  {
    path: "/briefing-lp-videoediting-s",
    redirect: "/briefing/lp-s/videoediting"
  },
  {
    path: "/briefing-lp-video-ad-s",
    redirect: "/briefing/lp-s/video-ad"
  },
  {
    path: "/briefing-lp-shopify-s",
    redirect: "/briefing/lp-s/shopify"
  },
  {
    path: "/briefing-lp-webdirection-s",
    redirect: "/briefing/lp-s/webdirection"
  },
  {
    path: "/briefing-lp-webmarketing-s",
    redirect: "/briefing/lp-s/webmarketing"
  },
  {
    path: "/briefing-lp-dx-s",
    redirect: "/briefing/lp-s/dx"
  },
  {
    path: "/briefing-lp-first-sidejob-s",
    redirect: "/briefing/lp-s/first-sidejob"
  },
  {
    path: "/briefing-lp-s",
    redirect: "/briefing/lp-s/programming"
  },
  {
    path: "/briefing-lp-all-s",
    redirect: "/briefing/lp-s/all"
  },
  {
    path: "/rails-bootcamp",
    redirect: "/course/rails"
  },
  {
    path: "/first-sidejob-bootcamp",
    redirect: "/course/first-sidejob"
  },
  {
    path: "/webdesign-bootcamp",
    redirect: "/course/webdesign"
  },
  {
    path: "/python-bootcamp",
    redirect: "/course/python"
  },
  {
    path: "/jobs",
    redirect: "/job"
  },
  {
    path: "/jobs/rails",
    redirect: "/job/rails"
  },
  {
    path: "/jobs/php",
    redirect: "/job/php"
  },
  {
    path: "/jobs/laravel",
    redirect: "/job/laravel"
  },
  {
    path: "/jobs/frontend",
    redirect: "/job/frontend"
  },
  {
    path: "/jobs/wordpress",
    redirect: "/job/wordpress"
  },
  {
    path: "/jobs/iphone",
    redirect: "/job/iphone"
  },
  {
    path: "/jobs/android",
    redirect: "/job/android"
  },
  {
    path: "/jobs/unity",
    redirect: "/job/unity"
  },
  {
    path: "/jobs/java",
    redirect: "/job/java"
  },
  {
    path: "/jobs/blockchain",
    redirect: "/job/blockchain"
  },
  {
    path: "/jobs/ai",
    redirect: "/job/ai"
  },
  {
    path: "/jobs/datascience",
    redirect: "/job/datascience"
  },
  {
    path: "/jobs/webdesign",
    redirect: "/job/webdesign"
  },
  {
    path: "/jobs/appdesign",
    redirect: "/job/appdesign"
  },
  {
    path: "/jobs/webdirection",
    redirect: "/job/webdirection"
  },
  {
    path: "/jobs/webmarketing",
    redirect: "/job/webmarketing"
  },
  {
    path: "/mentor-recruits-lp-rails",
    redirect: "/job/lp/rails"
  },
  {
    path: "/mentor-recruits-lp-appdesign",
    redirect: "/job/lp/appdesign"
  },
  {
    path: "/mentor-recruits-lp-ai",
    redirect: "/job/lp/ai"
  },
  {
    path: "/mentor-recruits-lp-webdesign",
    redirect: "/job/lp/webdesign"
  },
  {
    path: "/mentor-recruits-lp-frontend",
    redirect: "/job/lp/frontend"
  },
  {
    path: "/mentor-recruits-lp-datascience",
    redirect: "/job/lp/datascience"
  },
  {
    path: "/mentor-recruits-lp-webmarketing",
    redirect: "/job/lp/webmarketing"
  },
  {
    path: "/mentor-recruits-lp-unity",
    redirect: "/job/lp/unity"
  },
  {
    path: "/mentor-recruits-lp-laravel",
    redirect: "/job/lp/laravel"
  },
  {
    path: "/mentor-recruits-lp-java-servlet",
    redirect: "/job/lp/java-servlet"
  },
  {
    path: "/mentor-recruits-lp-wordpress",
    redirect: "/job/lp/wordpress"
  },
  {
    path: "/php-bootcamp",
    redirect: "/course/php"
  },
  {
    path: "/java-bootcamp",
    redirect: "/course/java"
  },
  {
    path: "/datascience-bootcamp",
    redirect: "/course/datascience"
  },
  {
    path: "/gas-bootcamp",
    redirect: "/course/gas"
  },
  {
    path: "/appdesign-bootcamp",
    redirect: "/course/appdesign"
  },
  {
    path: "/shopify-bootcamp",
    redirect: "/course/shopify"
  },
  {
    path: "/wordpress-bootcamp",
    redirect: "/course/wordpress"
  },
  {
    path: "/iphone-bootcamp",
    redirect: "/course/iphone"
  },
  {
    path: "/android-bootcamp",
    redirect: "/course/android"
  },
  {
    path: "/unity-bootcamp",
    redirect: "/course/unity"
  },
  {
    path: "/first-programming-bootcamp",
    redirect: "/course/first-programming"
  },
  {
    path: "/video-ad-bootcamp",
    redirect: "/course/video-ad"
  },
  {
    path: "/frontend-bootcamp",
    redirect: "/course/frontend"
  },
  {
    path: "/ai-bootcamp",
    redirect: "/course/ai"
  },
  {
    path: "/oss-bootcamp",
    redirect: "/course/oss"
  },
  {
    path: "/webdesign-freelance",
    redirect: "/course/webdesign-freelance"
  },
  {
    path: "/rails-portfolio-bootcamp",
    redirect: "/course/rails-portfolio"
  },
  {
    path: "/webmarketing-bootcamp",
    redirect: "/course/webmarketing"
  },
  {
    path: "/wix-bootcamp",
    redirect: "/course/wix"
  },
  {
    path: "/videoediting-bootcamp",
    redirect: "/course/videoediting"
  },
  {
    path: "/design-portfolio-bootcamp",
    redirect: "/course/design-portfolio"
  },
  {
    path: "/webdirection-bootcamp",
    redirect: "/course/webdirection"
  },
  {
    path: "/first-dx-bootcamp",
    redirect: "/course/first-dx"
  },
  {
    path: "/course/first-dx",
    redirect: "/"
  },
  {
    path: "/dx-management-bootcamp",
    redirect: "/course/dx-management"
  },
  {
    path: "/frontend-sidejob-bootcamp",
    redirect: "/course/frontend-sidejob"
  },
  {
    path: "/first-prompt-eng-bootcamp",
    redirect: "/course/first-prompt-engineering"
  },
  {
    path: "/trial-mentoring-tutorial",
    redirect: "/tutorial/trial-mentoring"
  },
  {
    path: "/counselling-tutorial",
    redirect: "/tutorial/counseling"
  },
  {
    path: "/htmlcss-training",
    redirect: "/training/htmlcss"
  },
  {
    path: "/bootstrap-training",
    redirect: "/training/bootstrap"
  },
  {
    path: "/github-training",
    redirect: "/training/github"
  },
  {
    path: "/photoshop-training",
    redirect: "/training/photoshop"
  },
  {
    path: "/pro/lp/jobchange_trial",
    redirect: "/pro/lp-s/jobchange-trial"
  },
  {
    path: "/webapp-frontend-set",
    redirect: "/set/rails-frontend"
  },
  {
    path: "/php-frontend-set",
    redirect: "/set/php-frontend"
  },
  {
    path: "/webdesign-wordpress-set",
    redirect: "/set/webdesign-wordpress"
  },
  {
    path: "/webdesign-webmarketing-set",
    redirect: "/set/webdesign-webmarketing"
  },
  {
    path: "/wordpress-webmarketing-set",
    redirect: "/set/wordpress-webmarketing"
  },
  {
    path: "/python-ai-set",
    redirect: "/set/python-ai"
  },
  {
    path: "/python-datascience-set",
    redirect: "/set/python-datascience"
  },
  {
    path: "/iphone-android-set",
    redirect: "/set/iphone-android"
  },
  {
    path: "/unity-iphone-set",
    redirect: "/set/unity-iphone"
  },
  {
    path: "/unity-android-set",
    redirect: "/set/unity-android"
  },
  {
    path: "/appdesign-iphone-set",
    redirect: "/set/appdesign-iphone"
  },
  {
    path: "/webdirection-webdesign-set",
    redirect: "/set/webdirection-webdesign"
  },
  {
    path: "/webdirection-webmarketing-set",
    redirect: "/set/webdirection-webmarketing"
  },
  {
    path: "/webapp-frontend-webdesign-set",
    redirect: "/set/rails-frontend-webdesign"
  },
  {
    path: "/php-frontend-webdesign-set",
    redirect: "/set/php-frontend-webdesign"
  },
  {
    path: "/iphone-android-appdesign-set",
    redirect: "/set/iphone-android-appdesign"
  },
  {
    path: "/python-ai-datascience-set",
    redirect: "/set/python-ai-datascience"
  },
  {
    path: "/webdesign-freelance-set",
    redirect: "/set/webdesign-freelance"
  },
  {
    path: "/frontend-sidejob-set",
    redirect: "/set/frontend-sidejob"
  },
  {
    path: "/python-prompt-set",
    redirect: "/set/python-first-prompt-engineering"
  },
  {
    path: "/lp-webdesign-freelance-s",
    redirect: "/set/webdesign-freelance-high-class-mentor"
  },
  {
    path: "/course/videoediting",
    redirect: "/moocres"
  },
  {
    path: "/briefing/videoediting",
    redirect: "/moocres"
  },
  {
    path: "/briefing/lp-s/videoediting",
    redirect: "/moocres"
  },
  {
    path: "/course/video-ad",
    redirect: "/moocres"
  },
  {
    path: "/briefing/video-ad",
    redirect: "/moocres"
  },
  {
    path: "/briefing/lp-s/video-ad",
    redirect: "/moocres"
  },
  {
    path: "/course/dx-management",
    redirect: "/course"
  },
  {
    path: "/course/webdirection",
    redirect: "/course"
  },
  {
    path: "/briefing/webdirection",
    redirect: "/course"
  },
  {
    path: "/briefing/lp-s/webdirection",
    redirect: "/course"
  },
  {
    path: "/set/webdirection-webdesign",
    redirect: "/course"
  },
  {
    path: "/set/webdirection-webmarketing",
    redirect: "/course"
  },
  {
    path: "/course/gas",
    redirect: "/course"
  },
  {
    path: "/briefing/gas",
    redirect: "/course"
  },
  {
    path: "/briefing/lp-s/gas",
    redirect: "/course"
  },
  {
    path: "/course/rails-portfolio",
    redirect: "/course"
  },
  {
    path: "/briefing/rails-portfolio",
    redirect: "/course"
  },
  {
    path: "/course/oss",
    redirect: "/course"
  },
  {
    path: "/job/webdirection",
    redirect: "/job"
  },
  {
    path: "/briefing/first-prompt-eng",
    redirect: "/briefing/first-prompt-engineering"
  },
  {
    path: "/web-production-mom-bootcamp",
    redirect: "/course/first-sidejob-mom"
  },
  {
    path: "/moocres-bootcamp",
    redirect: "/moocres"
  },
  {
    path: "/counseling/htmlcss-schedule-3",
    redirect: "/counseling/htmlcss-schedule"
  },
  {
    path: "/ly/counseling/lp/htmlcss-schedule",
    redirect: "/ly/counseling"
  },
  {
    path: "/ly/course/webapp",
    redirect: "/ly/course/jobchange"
  },
  {
    path: "/ly/course/data-basic",
    redirect: "/ly/course/first-chatgpt"
  },
  {
    path: "/ly/course/data-basic-ai-limited",
    redirect: "/ly/course/first-chatgpt"
  },
  {
    path: "/ly/course/data-basic-ai",
    redirect: "/ly/course/first-chatgpt"
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "benefits-reskilling",
    path: "/benefits/reskilling",
    component: () => import("/vercel/path0/pages/benefits/reskilling.vue")
  },
  {
    name: "biz-training-course-first-prompt-engineering",
    path: "/biz/training/course/first-prompt-engineering",
    meta: indexJFmZsJLqDNMeta || {},
    component: () => import("/vercel/path0/pages/biz/training/course/first-prompt-engineering/index.vue")
  },
  {
    name: "biz-training",
    path: "/biz/training",
    meta: indexVf2tJc0DDdMeta || {},
    component: () => import("/vercel/path0/pages/biz/training/index.vue")
  },
  {
    name: "biz-training-lp-team-team",
    path: "/biz/training/lp/team/:team()",
    meta: index9FE4cnbC5WMeta || {},
    component: () => import("/vercel/path0/pages/biz/training/lp/team/[team]/index.vue")
  },
  {
    name: "biz-training-operations",
    path: "/biz/training/operations",
    meta: indexiVwlYCgHgvMeta || {},
    component: () => import("/vercel/path0/pages/biz/training/operations/index.vue")
  },
  {
    name: "biz-training-special-generative-ai-series",
    path: "/biz/training/special/generative-ai-series",
    meta: indexSliKKjDjKJMeta || {},
    component: () => import("/vercel/path0/pages/biz/training/special/generative-ai-series/index.vue")
  },
  {
    name: "career-about",
    path: "/career-about",
    component: () => import("/vercel/path0/pages/career-about/index.vue")
  },
  {
    name: "company",
    path: "/company",
    meta: indexTHqTRxlhV2Meta || {},
    component: () => import("/vercel/path0/pages/company/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexDBbnZWdxZ3Meta || {},
    component: () => import("/vercel/path0/pages/contact/index.vue")
  },
  {
    name: "cookiepolicy",
    path: "/cookiepolicy",
    meta: indexuIEwXf9C56Meta || {},
    component: () => import("/vercel/path0/pages/cookiepolicy/index.vue")
  },
  {
    name: "counseling-htmlcss-schedule",
    path: "/counseling/htmlcss-schedule",
    component: () => import("/vercel/path0/pages/counseling/htmlcss-schedule.vue")
  },
  {
    name: "course-ai",
    path: "/course/ai",
    component: () => import("/vercel/path0/pages/course/ai.vue")
  },
  {
    name: "course-android",
    path: "/course/android",
    component: () => import("/vercel/path0/pages/course/android.vue")
  },
  {
    name: "course-datascience",
    path: "/course/datascience",
    component: () => import("/vercel/path0/pages/course/datascience.vue")
  },
  {
    name: "course-design-portfolio",
    path: "/course/design-portfolio",
    component: () => import("/vercel/path0/pages/course/design-portfolio.vue")
  },
  {
    name: "course-first-programming",
    path: "/course/first-programming",
    component: () => import("/vercel/path0/pages/course/first-programming.vue")
  },
  {
    name: "course-first-prompt-engineering",
    path: "/course/first-prompt-engineering",
    component: () => import("/vercel/path0/pages/course/first-prompt-engineering.vue")
  },
  {
    name: "course-first-sidejob-oneonone-plan",
    path: "/course/first-sidejob-oneonone-plan",
    component: () => import("/vercel/path0/pages/course/first-sidejob-oneonone-plan.vue")
  },
  {
    name: "course-first-sidejob",
    path: "/course/first-sidejob",
    component: () => import("/vercel/path0/pages/course/first-sidejob.vue")
  },
  {
    name: "course-frontend",
    path: "/course/frontend",
    component: () => import("/vercel/path0/pages/course/frontend.vue")
  },
  {
    name: "course",
    path: "/course",
    component: () => import("/vercel/path0/pages/course/index.vue")
  },
  {
    name: "course-iphone",
    path: "/course/iphone",
    component: () => import("/vercel/path0/pages/course/iphone.vue")
  },
  {
    name: "course-java",
    path: "/course/java",
    component: () => import("/vercel/path0/pages/course/java.vue")
  },
  {
    name: "course-llm-development",
    path: "/course/llm-development",
    component: () => import("/vercel/path0/pages/course/llm-development.vue")
  },
  {
    name: "course-occupation",
    path: "/course/occupation",
    component: () => import("/vercel/path0/pages/course/occupation.vue")
  },
  {
    name: "course-ordermade-entry",
    path: "/course/ordermade-entry",
    component: () => import("/vercel/path0/pages/course/ordermade-entry.vue")
  },
  {
    name: "course-ordermade",
    path: "/course/ordermade",
    component: () => import("/vercel/path0/pages/course/ordermade.vue")
  },
  {
    name: "course-python",
    path: "/course/python",
    component: () => import("/vercel/path0/pages/course/python.vue")
  },
  {
    name: "course-unity",
    path: "/course/unity",
    component: () => import("/vercel/path0/pages/course/unity.vue")
  },
  {
    name: "course-webdesign",
    path: "/course/webdesign",
    component: () => import("/vercel/path0/pages/course/webdesign.vue")
  },
  {
    name: "course-webdevelopment-advanced",
    path: "/course/webdevelopment-advanced",
    component: () => import("/vercel/path0/pages/course/webdevelopment-advanced.vue")
  },
  {
    name: "course-webmarketing",
    path: "/course/webmarketing",
    component: () => import("/vercel/path0/pages/course/webmarketing.vue")
  },
  {
    name: "course-wordpress",
    path: "/course/wordpress",
    component: () => import("/vercel/path0/pages/course/wordpress.vue")
  },
  {
    name: "diagnoses-completed_a",
    path: "/diagnoses/completed_a",
    meta: completed_a7gPeWqF67jMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_a.vue")
  },
  {
    name: "diagnoses-completed_b",
    path: "/diagnoses/completed_b",
    meta: completed_bbnbeRPPWHpMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_b.vue")
  },
  {
    name: "diagnoses-completed_c",
    path: "/diagnoses/completed_c",
    meta: completed_cgh3OO7r4WVMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_c.vue")
  },
  {
    name: "diagnoses-completed_d",
    path: "/diagnoses/completed_d",
    meta: completed_dX1e4RplamUMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_d.vue")
  },
  {
    name: "diagnoses-completed_e",
    path: "/diagnoses/completed_e",
    meta: completed_eD8zMBDBK96Meta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_e.vue")
  },
  {
    name: "diagnoses-completed_f",
    path: "/diagnoses/completed_f",
    meta: completed_fA8bKPbdwb6Meta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_f.vue")
  },
  {
    name: "diagnoses-completed_g",
    path: "/diagnoses/completed_g",
    meta: completed_gssJYDJsQr0Meta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_g.vue")
  },
  {
    name: "diagnoses-completed_i",
    path: "/diagnoses/completed_i",
    meta: completed_isPVNPuVTtyMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_i.vue")
  },
  {
    name: "diagnoses-completed_j",
    path: "/diagnoses/completed_j",
    meta: completed_jpFNTP6gKYzMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_j.vue")
  },
  {
    name: "diagnoses-completed_k",
    path: "/diagnoses/completed_k",
    meta: completed_kfqdu3TYFgKMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_k.vue")
  },
  {
    name: "diagnoses-completed_l",
    path: "/diagnoses/completed_l",
    meta: completed_lgNhJvf2A3WMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_l.vue")
  },
  {
    name: "diagnoses-completed_n",
    path: "/diagnoses/completed_n",
    meta: completed_nXAc9TiA0CKMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_n.vue")
  },
  {
    name: "diagnoses-completed_o",
    path: "/diagnoses/completed_o",
    meta: completed_odUe2A7cV5UMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_o.vue")
  },
  {
    name: "diagnoses-completed_p",
    path: "/diagnoses/completed_p",
    meta: completed_pYbkne6HDV3Meta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_p.vue")
  },
  {
    name: "diagnoses-completed_q",
    path: "/diagnoses/completed_q",
    meta: completed_qYzsGpHsPAQMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_q.vue")
  },
  {
    name: "diagnoses-completed_r",
    path: "/diagnoses/completed_r",
    meta: completed_ruLO7xwUZW1Meta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_r.vue")
  },
  {
    name: "diagnoses-completed_s",
    path: "/diagnoses/completed_s",
    meta: completed_scHlDGnsgDxMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_s.vue")
  },
  {
    name: "diagnoses-completed_t",
    path: "/diagnoses/completed_t",
    meta: completed_t7rwAxEdQVxMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/completed_t.vue")
  },
  {
    name: "diagnoses-q1",
    path: "/diagnoses/q1",
    meta: q1bfdinuVYi9Meta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q1.vue")
  },
  {
    name: "diagnoses-q2_a",
    path: "/diagnoses/q2_a",
    meta: q2_aBpKZ8qldvFMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q2_a.vue")
  },
  {
    name: "diagnoses-q2_b",
    path: "/diagnoses/q2_b",
    meta: q2_bBg0jHoC3kjMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q2_b.vue")
  },
  {
    name: "diagnoses-q2_c",
    path: "/diagnoses/q2_c",
    meta: q2_cp8O6wPMhowMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q2_c.vue")
  },
  {
    name: "diagnoses-q2_d",
    path: "/diagnoses/q2_d",
    meta: q2_dmpziMC4GvjMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q2_d.vue")
  },
  {
    name: "diagnoses-q2_e",
    path: "/diagnoses/q2_e",
    meta: q2_eoQ2AginqY1Meta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q2_e.vue")
  },
  {
    name: "diagnoses-q3_a",
    path: "/diagnoses/q3_a",
    meta: q3_ala8GrIjZM4Meta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q3_a.vue")
  },
  {
    name: "diagnoses-q3_b",
    path: "/diagnoses/q3_b",
    meta: q3_bG4GSsVa2JKMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q3_b.vue")
  },
  {
    name: "diagnoses-q3_c",
    path: "/diagnoses/q3_c",
    meta: q3_cMDMHLIXFezMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q3_c.vue")
  },
  {
    name: "diagnoses-q3_f",
    path: "/diagnoses/q3_f",
    meta: q3_fqoV6IEEcW1Meta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q3_f.vue")
  },
  {
    name: "diagnoses-q4_a",
    path: "/diagnoses/q4_a",
    meta: q4_a3AQQwgBd5FMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/q4_a.vue")
  },
  {
    name: "diagnoses-top",
    path: "/diagnoses/top",
    meta: topyz3qXdT99tMeta || {},
    component: () => import("/vercel/path0/pages/diagnoses/top.vue")
  },
  {
    name: "errors-404",
    path: "/errors/404",
    component: () => import("/vercel/path0/pages/errors/404.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index2",
    path: "/index2",
    component: () => import("/vercel/path0/pages/index2.vue")
  },
  {
    name: "job-ai",
    path: "/job/ai",
    component: () => import("/vercel/path0/pages/job/ai.vue")
  },
  {
    name: "job-android",
    path: "/job/android",
    component: () => import("/vercel/path0/pages/job/android.vue")
  },
  {
    name: "job-datascience",
    path: "/job/datascience",
    component: () => import("/vercel/path0/pages/job/datascience.vue")
  },
  {
    name: "job-frontend",
    path: "/job/frontend",
    component: () => import("/vercel/path0/pages/job/frontend.vue")
  },
  {
    name: "job",
    path: "/job",
    component: () => import("/vercel/path0/pages/job/index.vue")
  },
  {
    name: "job-iphone",
    path: "/job/iphone",
    component: () => import("/vercel/path0/pages/job/iphone.vue")
  },
  {
    name: "job-java",
    path: "/job/java",
    component: () => import("/vercel/path0/pages/job/java.vue")
  },
  {
    name: "job-laravel",
    path: "/job/laravel",
    component: () => import("/vercel/path0/pages/job/laravel.vue")
  },
  {
    name: "job-php",
    path: "/job/php",
    component: () => import("/vercel/path0/pages/job/php.vue")
  },
  {
    name: "job-unity",
    path: "/job/unity",
    component: () => import("/vercel/path0/pages/job/unity.vue")
  },
  {
    name: "job-webdesign",
    path: "/job/webdesign",
    component: () => import("/vercel/path0/pages/job/webdesign.vue")
  },
  {
    name: "job-webmarketing",
    path: "/job/webmarketing",
    component: () => import("/vercel/path0/pages/job/webmarketing.vue")
  },
  {
    name: "jobchange",
    path: "/jobchange",
    component: () => import("/vercel/path0/pages/jobchange/index.vue")
  },
  {
    name: "law",
    path: "/law",
    meta: indexwBWcviDWKwMeta || {},
    component: () => import("/vercel/path0/pages/law/index.vue")
  },
  {
    name: "lp-branded",
    path: "/lp/branded",
    meta: indexR0mMjgzY36Meta || {},
    component: () => import("/vercel/path0/pages/lp/branded/index.vue")
  },
  {
    name: "lp-branded-lp-1",
    path: "/lp/branded/lp-1",
    meta: lp_4511ASTrUcpSWMeta || {},
    component: () => import("/vercel/path0/pages/lp/branded/lp-1.vue")
  },
  {
    name: "lp-branded-lp-capex",
    path: "/lp/branded/lp-capex",
    meta: lp_45capexw5sng2CrlyMeta || {},
    component: () => import("/vercel/path0/pages/lp/branded/lp-capex.vue")
  },
  {
    name: "lp-branded-lp-ceoclone",
    path: "/lp/branded/lp-ceoclone",
    meta: lp_45ceoclone1JOtlS5jnyMeta || {},
    component: () => import("/vercel/path0/pages/lp/branded/lp-ceoclone.vue")
  },
  {
    name: "lp-branded-lp-kakaku",
    path: "/lp/branded/lp-kakaku",
    meta: lp_45kakakuWkYvhhj7mpMeta || {},
    component: () => import("/vercel/path0/pages/lp/branded/lp-kakaku.vue")
  },
  {
    name: "lp-moocres-schedule-form",
    path: "/lp/moocres/schedule-form",
    meta: schedule_45formUCvohPgBYMMeta || {},
    component: () => import("/vercel/path0/pages/lp/moocres/schedule-form.vue")
  },
  {
    name: "lp-sidejob-aff-1",
    path: "/lp/sidejob/aff-1",
    meta: aff_45184lNTZWLaQMeta || {},
    component: () => import("/vercel/path0/pages/lp/sidejob/aff-1.vue")
  },
  {
    name: "ly-contact-biz",
    path: "/ly/contact-biz",
    meta: contact_45bizctG1WHsDkWMeta || {},
    component: () => import("/vercel/path0/pages/ly/contact-biz.vue")
  },
  {
    name: "ly-contact",
    path: "/ly/contact",
    meta: contactcqWo7WTDl2Meta || {},
    component: () => import("/vercel/path0/pages/ly/contact.vue")
  },
  {
    name: "ly-counseling-ceoclone",
    path: "/ly/counseling-ceoclone",
    meta: counseling_45ceoclonemSAFO6JhpiMeta || {},
    component: () => import("/vercel/path0/pages/ly/counseling-ceoclone.vue")
  },
  {
    name: "ly-counseling-line",
    path: "/ly/counseling-line",
    meta: counseling_45lineVvhKsEKDN5Meta || {},
    component: () => import("/vercel/path0/pages/ly/counseling-line.vue")
  },
  {
    name: "ly-counseling",
    path: "/ly/counseling",
    meta: counseling84rvMWUo9EMeta || {},
    component: () => import("/vercel/path0/pages/ly/counseling.vue")
  },
  {
    name: "ly-course-chatgpt-benefit",
    path: "/ly/course/chatgpt-benefit",
    meta: chatgpt_45benefitp7JNHpdptkMeta || {},
    component: () => import("/vercel/path0/pages/ly/course/chatgpt-benefit.vue")
  },
  {
    name: "ly-course-chatgpt",
    path: "/ly/course/chatgpt",
    meta: chatgptOk8qzM6FCPMeta || {},
    component: () => import("/vercel/path0/pages/ly/course/chatgpt.vue")
  },
  {
    name: "ly-course-jobchange",
    path: "/ly/course/jobchange",
    meta: jobchangeHICJGBzcIPMeta || {},
    component: () => import("/vercel/path0/pages/ly/course/jobchange.vue")
  },
  {
    name: "ly-course-webapp-basic",
    path: "/ly/course/webapp-basic",
    meta: webapp_45basicQ1WBVL3C20Meta || {},
    component: () => import("/vercel/path0/pages/ly/course/webapp-basic.vue")
  },
  {
    name: "ly-course-webapp-practice",
    path: "/ly/course/webapp-practice",
    meta: webapp_45practice38XQYzFqE2Meta || {},
    component: () => import("/vercel/path0/pages/ly/course/webapp-practice.vue")
  },
  {
    name: "ly-law",
    path: "/ly/law",
    meta: lawpR8FVHyqAKMeta || {},
    component: () => import("/vercel/path0/pages/ly/law.vue")
  },
  {
    name: "ly-login",
    path: "/ly/login",
    meta: loginXmmZrncU0JMeta || {},
    component: () => import("/vercel/path0/pages/ly/login.vue")
  },
  {
    name: "ly-lp-counseling-form",
    path: "/ly/lp/counseling-form",
    meta: counseling_45formCrkt8UsDGRMeta || {},
    component: () => import("/vercel/path0/pages/ly/lp/counseling-form.vue")
  },
  {
    name: "ly-lp-counseling-kakaku",
    path: "/ly/lp/counseling-kakaku",
    meta: counseling_45kakakufyAurXKAnqMeta || {},
    component: () => import("/vercel/path0/pages/ly/lp/counseling-kakaku.vue")
  },
  {
    name: "ly-lp-counseling-ly",
    path: "/ly/lp/counseling-ly",
    meta: counseling_45ly1CnFb7GCnRMeta || {},
    component: () => import("/vercel/path0/pages/ly/lp/counseling-ly.vue")
  },
  {
    name: "ly-lp-counseling",
    path: "/ly/lp/counseling",
    meta: counselingyQmIPvUburMeta || {},
    component: () => import("/vercel/path0/pages/ly/lp/counseling.vue")
  },
  {
    name: "ly-privacypolicy",
    path: "/ly/privacypolicy",
    meta: privacypolicy6EhgJwAWQWMeta || {},
    component: () => import("/vercel/path0/pages/ly/privacypolicy.vue")
  },
  {
    name: "ly-terms",
    path: "/ly/terms",
    meta: termsUoYkUh4pqCMeta || {},
    component: () => import("/vercel/path0/pages/ly/terms.vue")
  },
  {
    name: "ly-trial",
    path: "/ly/trial",
    meta: trialgKqqGcS0l9Meta || {},
    component: () => import("/vercel/path0/pages/ly/trial.vue")
  },
  {
    name: "ly-tutorial-trial-mentoring",
    path: "/ly/tutorial/trial-mentoring",
    meta: trial_45mentoringoHiCcFNejhMeta || {},
    component: () => import("/vercel/path0/pages/ly/tutorial/trial-mentoring.vue")
  },
  {
    name: "ly-users-passwords",
    path: "/ly/users/passwords",
    meta: passwords1mFR4I4G80Meta || {},
    component: () => import("/vercel/path0/pages/ly/users/passwords.vue")
  },
  {
    name: "price",
    path: "/price",
    component: () => import("/vercel/path0/pages/price/index.vue")
  },
  {
    name: "privacypolicy",
    path: "/privacypolicy",
    meta: indexbg3ekTJ1BXMeta || {},
    component: () => import("/vercel/path0/pages/privacypolicy/index.vue")
  },
  {
    name: "set-first-sidejob-webdesign",
    path: "/set/first-sidejob-webdesign",
    component: () => import("/vercel/path0/pages/set/first-sidejob-webdesign.vue")
  },
  {
    name: "set-iphone-android",
    path: "/set/iphone-android",
    component: () => import("/vercel/path0/pages/set/iphone-android.vue")
  },
  {
    name: "set-python-ai-datascience",
    path: "/set/python-ai-datascience",
    component: () => import("/vercel/path0/pages/set/python-ai-datascience.vue")
  },
  {
    name: "set-python-ai",
    path: "/set/python-ai",
    component: () => import("/vercel/path0/pages/set/python-ai.vue")
  },
  {
    name: "set-python-datascience",
    path: "/set/python-datascience",
    component: () => import("/vercel/path0/pages/set/python-datascience.vue")
  },
  {
    name: "set-python-first-prompt-engineering",
    path: "/set/python-first-prompt-engineering",
    component: () => import("/vercel/path0/pages/set/python-first-prompt-engineering.vue")
  },
  {
    name: "set-unity-android",
    path: "/set/unity-android",
    component: () => import("/vercel/path0/pages/set/unity-android.vue")
  },
  {
    name: "set-unity-iphone",
    path: "/set/unity-iphone",
    component: () => import("/vercel/path0/pages/set/unity-iphone.vue")
  },
  {
    name: "set-webdesign-webmarketing",
    path: "/set/webdesign-webmarketing",
    component: () => import("/vercel/path0/pages/set/webdesign-webmarketing.vue")
  },
  {
    name: "set-webdevelopment-advanced",
    path: "/set/webdevelopment-advanced",
    component: () => import("/vercel/path0/pages/set/webdevelopment-advanced.vue")
  },
  {
    name: "set-webengineer-jobchange",
    path: "/set/webengineer-jobchange",
    component: () => import("/vercel/path0/pages/set/webengineer-jobchange.vue")
  },
  {
    name: "sidejob",
    path: "/sidejob",
    component: () => import("/vercel/path0/pages/sidejob/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index9OiDgfx7OcMeta || {},
    component: () => import("/vercel/path0/pages/terms/index.vue")
  },
  {
    name: "training-photoshop",
    path: "/training/photoshop",
    component: () => import("/vercel/path0/pages/training/photoshop.vue")
  },
  {
    name: "tutorial-trial-mentoring",
    path: "/tutorial/trial-mentoring",
    component: () => import("/vercel/path0/pages/tutorial/trial-mentoring.vue")
  },
  {
    name: "upgrade-features-axios",
    path: "/upgrade/features/axios",
    component: () => import("/vercel/path0/pages/upgrade/features/axios.vue")
  },
  {
    name: "upgrade-features-error",
    path: "/upgrade/features/error",
    component: () => import("/vercel/path0/pages/upgrade/features/error.vue")
  },
  {
    name: "upgrade-features-form-checkbox-interested",
    path: "/upgrade/features/form-checkbox-interested",
    component: () => import("/vercel/path0/pages/upgrade/features/form-checkbox-interested.vue")
  },
  {
    name: "upgrade-features-recapcha",
    path: "/upgrade/features/recapcha",
    component: () => import("/vercel/path0/pages/upgrade/features/recapcha.vue")
  },
  {
    name: "upgrade-scroll-intersection-observer",
    path: "/upgrade/scroll/intersection-observer",
    component: () => import("/vercel/path0/pages/upgrade/scroll/intersection-observer.vue")
  },
  {
    name: "upgrade-scroll-scroll-spy",
    path: "/upgrade/scroll/scroll-spy",
    component: () => import("/vercel/path0/pages/upgrade/scroll/scroll-spy.vue")
  },
  {
    name: "upgrade-scroll-scroll-trigger",
    path: "/upgrade/scroll/scroll-trigger",
    component: () => import("/vercel/path0/pages/upgrade/scroll/scroll-trigger.vue")
  },
  {
    name: "upgrade-scroll-smooth-scroll",
    path: "/upgrade/scroll/smooth-scroll",
    component: () => import("/vercel/path0/pages/upgrade/scroll/smooth-scroll.vue")
  },
  {
    name: "upgrade-scroll-vueuse-element-visibility",
    path: "/upgrade/scroll/vueuse-element-visibility",
    component: () => import("/vercel/path0/pages/upgrade/scroll/vueuse-element-visibility.vue")
  },
  {
    name: "upgrade-scroll-vueuse-intersection-observer",
    path: "/upgrade/scroll/vueuse-intersection-observer",
    component: () => import("/vercel/path0/pages/upgrade/scroll/vueuse-intersection-observer.vue")
  },
  {
    name: "upgrade-ui-modal-default",
    path: "/upgrade/ui/modal-default",
    component: () => import("/vercel/path0/pages/upgrade/ui/modal-default.vue")
  },
  {
    name: "upgrade-ui-modal-footer",
    path: "/upgrade/ui/modal-footer",
    component: () => import("/vercel/path0/pages/upgrade/ui/modal-footer.vue")
  },
  {
    name: "upgrade-ui-modal-form-comfirm",
    path: "/upgrade/ui/modal-form-comfirm",
    component: () => import("/vercel/path0/pages/upgrade/ui/modal-form-comfirm.vue")
  },
  {
    name: "upgrade-ui-modal-form",
    path: "/upgrade/ui/modal-form",
    component: () => import("/vercel/path0/pages/upgrade/ui/modal-form.vue")
  },
  {
    name: "upgrade-ui-swiper-slide-three",
    path: "/upgrade/ui/swiper-slide-three",
    component: () => import("/vercel/path0/pages/upgrade/ui/swiper-slide-three.vue")
  },
  {
    name: "upgrade-ui-swiper-slide-two",
    path: "/upgrade/ui/swiper-slide-two",
    component: () => import("/vercel/path0/pages/upgrade/ui/swiper-slide-two.vue")
  },
  {
    name: "upgrade-ui-vue3-lottie",
    path: "/upgrade/ui/vue3-lottie",
    component: () => import("/vercel/path0/pages/upgrade/ui/vue3-lottie.vue")
  },
  {
    name: "works",
    path: "/works",
    component: () => import("/vercel/path0/pages/works/index.vue")
  },
  {
    name: "error_404",
    path: "/:pathMatch(.*)*",
    component: () => import("/vercel/path0/pages/errors/404.vue")
  }
]